import { render, staticRenderFns } from "./HeaderTopBarDesktop.vue?vue&type=template&id=20ff5cb9&scoped=true"
import script from "./HeaderTopBarDesktop.vue?vue&type=script&lang=ts"
export * from "./HeaderTopBarDesktop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ff5cb9",
  null
  
)

export default component.exports